import Lines from "../components/Lines";
import "./AluminiDynamicPages.scss";
import { FaLink } from "react-icons/fa";

const AluminiDynamicPages = ({ title, content, title2, linkbtn }) => {

    return (
        <section className="aluminiDynamicPageMainContainer">
            <header style={{ paddingBottom: "10px" }}>
                <h2>{title}</h2>
                <div style={{ display: "flex" }}>
                    <span className="lines-parent" style={{ fontFamily: "Arial" }}>
                        <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                    </span>
                </div>
            </header>
            <article>
                <p>{content}</p>
            </article>
            {title == "Objectives" && (
                <article className="section-two">
                    <h2>{title2 && title2}</h2>
                    <div style={{ display: "flex" }}>
                        <span className="lines-parent" style={{ fontFamily: "Arial" }}>
                            <Lines count={25} color="#116C4A" fontSize={2.3} spacing={0.1} thickness={700} />
                        </span>
                    </div>
                </article>
            )}

            {title == 'Objectives' &&
                (
                    <div style={{ display: "flex", justifyContent: "center", paddingTop: "20px" }}>
                        <button className="link-btn-for-objectives">
                            <span className="logoParent">
                                <FaLink className="link-icon" />
                            </span>
                            <a className="objective-link"  href="https://forms.gle/nCAmgYbr8yTashxw9" target="_blank">www.nicasadmission.com</a>
                        </button>
                    </div>
                )
            }
        </section >
    );
};

export default AluminiDynamicPages;
